"use client";

import { useQuery } from "convex/react";
import { useConvexAuth } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";
import type { BillingState } from "@/lib/plan";

/**
 * The user's billing state from the Convex `billingState` mirror — reactive,
 * so charges/checkouts update every consumer live. Replaces autumn-js
 * useCustomer(). `billing` is null until the first sync (AutumnClientProvider
 * triggers one on sign-in).
 */
export function useBillingState(): { billing: BillingState | null; isLoading: boolean } {
  const { isAuthenticated } = useConvexAuth();
  const state = useQuery(api.autumn.getMyBillingState, isAuthenticated ? {} : "skip");
  return {
    billing: (state as BillingState | null | undefined) ?? null,
    isLoading: isAuthenticated && state === undefined,
  };
}
